import classNames from 'classnames';

import style from './light-bulb.module.css';

interface LightBulbProps {
  className: string;
}

const LightBulb = ({
  className,
}: LightBulbProps) => {
  return (
    <div className={classNames(style.light, className)}>
      <div className={style.bulb} />
    </div>
  );
};

export default LightBulb;
